import { render, staticRenderFns } from "./BabyIcon.vue?vue&type=template&id=3c8d06d4&scoped=true&"
import script from "./BabyIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BabyIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d06d4",
  null
  
)

export default component.exports